export default {"src":"/_next/static/media/close-icon.c2a0b7f5.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};